<ng-container *ngIf="orderCharges$ | async as orderCharges">
  <ng-container *ngIf="orderCharges.charges.size > 0">
    <mat-expansion-panel class="charges-panel" [expanded]="expanded">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'FRONTEND.STORE.RECURRING_CHARGES_SUMMARY.TITLE' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ng-container *ngFor="let frequencyKey of orderCharges.charges.keys()">
        <div class="charges-row">
          <span>
            {{ 'FRONTEND.STORE.PERIODS.' + frequencyKey | translate }}
          </span>
          <span class="recurring-charge">
            <billing-ui-simple-price-display
              [price]="(orderCharges.charges.get(frequencyKey) || 0) * 100"
              [currencyCode]="orderCharges.currency"
              [frequency]="Frequency.ONE_TIME"
            ></billing-ui-simple-price-display>
          </span>
        </div>
      </ng-container>
    </mat-expansion-panel>
  </ng-container>
</ng-container>
